<template>
	<box :customer="true" :autoLoad="true" :ref="boxRef" title="线上商品" :width="800" :index="0" @hide="hide"
		@submit="submit" moduleName="proofbill" :store="store" selectType="checkbox" @boxdataload="boxdataload" />
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			invoiceNumber: {
				default: () => {
					return null
				}
			},
			currentrow: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					columns: [{
						field: 'realskuId',
						title: 'sku编码',	
						render:"$input",
						span:8,
						props:{
							querySearchfield:null
						}
					},{
						field: 'itemCode',
						title: '商品编码',
						render:"$input",
						span:8,
						props:{
							querySearchfield:null
						}
					},{
						field: 'goodsName',
						title: '商品名称',	
						render:"$input",
						span:8,
						props:{
							querySearchfield:null
						}
					},{
						field: 'skuNametrim',
						title: '规格型号',
						render:"$input",
						defaultValue:null,
						span:8,
						props:{							
							querySearchfield:null
						}
					}],
					buttons:[],
					pagerConfig: {
						currentPage: 1,
						pageSize: 20,
						enabled: true,
						pageSizes: [10,20, 50, 200],
						force: false
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show
			// this.box.checkMethod = ({
			// 	row
			// }) => {
			// 	return !row.reconciliationbilldetailid
			// }

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			
			show() {
				if (this.box.getTable()) {
					this.box.getTable().commitProxy('query')
				}
			},
			initList() {
				if (!this.box.gridOptions) {
					this.boxConfig.columns.forEach((item)=>{
						if(item.field == 'skuNametrim'){
							item.defaultValue = this.currentrow?this.currentrow.spectrim:null
						}
					})
					this.box.initBox(this.boxConfig)
				}
			},
			list(page, form, other) {
				return new Promise((resolve, reject) => {
					this.$api.invoice.getoutputinvoicematchinfo(
						{
							type: 'sku',
							invoiceNumber:this.invoiceNumber,
							...page,
							...form,
							...other
						},						
					).then((res) => {
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>